import { render, staticRenderFns } from "./lazy2.vue?vue&type=template&id=30a27e3f&scoped=true&"
import script from "./lazy2.vue?vue&type=script&lang=js&"
export * from "./lazy2.vue?vue&type=script&lang=js&"
import style0 from "./lazy2.vue?vue&type=style&index=0&id=30a27e3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a27e3f",
  null
  
)

export default component.exports